<template>
  <div v-if="kundenLink == ''">
    <UserLogin v-if="!loggedIn" @Login="login"/>
    <router-view @Logout="logout" v-if="loggedIn" />
  </div>
  <div v-if="kundenLink != ''">
    <document-access :customerLink="kundenLink" :Year="currentYear" :standAlone="kundeStandAlone" />
  </div>

</template>

<script language="ts">
import { reactive, ref, toRefs , watch} from "vue";
import UserLogin from "@/components/User/Login.vue"
import { useRoute } from 'vue-router';
import  router  from '@/router/index';
import DocumentAccess from "@/components/Reports/DocumentAccess.vue";



export default {
  components: {
    UserLogin,
    DocumentAccess,
  },
  name: "app",
  inheritAttrs: false,

  setup() {
    const loggedIn = ref(false);
    const kundenLink = ref();
    const kundeStandAlone = ref(true);
    const currentYear = ref(2025);

    function login() {
       console.log("Login")
      loggedIn.value = true;
    }

    function logout() {
      console.log("Logout")
      loggedIn.value = false;
    }


    // router.beforeEach((to, from, next) => {
    //   const x = to.params; 
    //   if (x.kundenLink == undefined) {
    //     next();
    //     return;
    //   }
    //   next({
    //     name: "customerLink",
    //     params: { kundenLink: x.kundenLink, year: 2021 }
    // });
    // });

    router.beforeEach((to, from, next) => {
      const x = to.params;
      kundenLink.value  = "";
      if (x.kundenLink != undefined) {
        kundenLink.value = x.kundenLink
        console.log(kundenLink.value)
      }
      next();
    });
    

    return {
      loggedIn,
      login,
      logout,
      kundenLink,
      currentYear,
      kundeStandAlone
    };
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

button.accordion-button {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.k-grid {
  font-size: 12px !important;
}

  .landingpage__container {
    max-width: 100px !important;
    min-width: 800px;
    margin-top: 5%;
    margin-bottom: 5%;
  }

  .background__image {  
  width: 100%;
  height: 100%;
  background-size: cover;
  background-origin: border-box;
  background-clip: border-box;
  //background-position-x: -10vw;
  background-position-y: -7.6vh;
  background-attachment: fixed;
  background-repeat: no-repeat;
  z-index: -1000;
}

.k-grid tbody td {
    text-overflow: clip; /* prevent the ellipsis behavior */
    overflow-wrap: break-word;
}

</style>

